/* eslint-disable linebreak-style */
import { errorToMessage } from '../../../errorMessaging';

// Acknowledgement means the available adapter accepted the call, not vendor ingestion.
// Legacy callers keep their undefined return; exposure tracking opts in to retries.
export const triggerAlloyTrack = (eventName, payload, profile, { acknowledge = false } = {}) => {
  if (acknowledge && typeof window.uopxDataLayer?.track !== 'function') return false;
  try {
    const result = window.uopxDataLayer.track(eventName, payload, profile);
    if (acknowledge) {
      if (typeof result?.then === 'function') {
        return Promise.resolve(result).then(value => value !== false, () => false);
      }
      return result !== false;
    }
  } catch (error) {
    if (acknowledge) return false;
    // This will trigger an error event to full story
    errorToMessage('triggerAlloyTrack error');
  }
  return undefined;
};

export const triggerAlloyPageView = (eventData, profile) => {
  try {
    window.uopxDataLayer.page(eventData, profile);
  } catch (error) {
    // This will trigger an error event to full story
    errorToMessage('triggerAlloyPageView error');
  }
};

export default {
  triggerAlloyTrack,
  triggerAlloyPageView,
};
